
<app-cmnt-list [featureType] = "'home'" [cmntType]= "'Htstmnl'" [parentHdrId] = chapter?chapter:0  > </app-cmnt-list>

<!--[ovrSite] = '"all"'-->